<!-- 套餐修改 -->
<template>
  <div class="apply" v-loading="loading">
    <back />
    <el-form :model="ruleForm" label-width="150px" class="demo-ruleForm">
      <div class="form">
        <div class="title">基本信息:</div>
        <el-row class="dialog_row">
          <el-col :span="8">
            <div class="pic">
              <div style="font-size: 14px;font-weight: 400;margin-right: 20px;"> 项目图片:</div>
              <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover" :src="(ruleForm.urlList && ruleForm.urlList.length > 0) ? ruleForm.urlList[0] : ''" :preview-src-list="(ruleForm.urlList && ruleForm.urlList.length > 0) ? [ruleForm.urlList[0]] : []">
                </el-image></div>
              <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover" :src="(ruleForm.urlList && ruleForm.urlList.length > 1) ? ruleForm.urlList[1] : ''" :preview-src-list="(ruleForm.urlList && ruleForm.urlList.length > 1) ? [ruleForm.urlList[1]] : []">
                </el-image></div>
              <div class="picbox"><el-image style="width: 100px; height: 100px; border-radius: 6px;" fit="cover" :src="(ruleForm.urlList && ruleForm.urlList.length > 2) ? ruleForm.urlList[2] : ''" :preview-src-list="(ruleForm.urlList && ruleForm.urlList.length > 2) ? [ruleForm.urlList[2]] : []">
                </el-image></div>
            </div>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col :span="8">
            <el-form-item label="项目套餐名称:" prop="packageName">
              <el-input v-model="ruleForm.packageName" placeholder="请输入项目套餐名称" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="原价(元):" prop="originalPrice">
              <el-input v-model="ruleForm.originalPrice" placeholder="自动计算原价(元)" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="套餐价(元):" prop="discountPrice">
              <el-input v-model="ruleForm.discountPrice" placeholder="自动计算套餐价(元)" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="display: flex; justify-content: space-between;align-items: center;">
          <div class="title">套餐项目:</div>
        </div>
        <div class="g_table" style="margin-bottom: 20px; overflow: auto">
          <el-table :data="dataList" max-height="540">
            <el-table-column label="序号" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="projectName" label="项目名称"></el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="categoryName" label="分类"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="durationMinute" label="服务时长(min)">
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="commissionRate" label="提成比例(%)">
              <template slot-scope="scope">
                {{ scope.row.commissionRate ? scope.row.commissionRate : '——' }}
              </template>
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="commissionAmount" label="提成金额(元)">
              <template slot-scope="scope">
                {{ scope.row.commissionAmount ? scope.row.commissionAmount : '——' }}
              </template>
            </el-table-column>
            <el-table-column min-width="80" show-overflow-tooltip prop="projectCount" label="次数"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="originalPrice" label="原售价(元)"></el-table-column>
            <el-table-column min-width="120" show-overflow-tooltip prop="discountPrice" label="优惠价(元)" align="center">
            </el-table-column>
          </el-table>
        </div>
        <el-divider></el-divider>
        <div class="title">审核信息:</div>
        <div class="container">
          <div class="item">申请时间：{{ruleForm.createdTime}}</div>
          <div class="item">审核时间：{{ruleForm.auditDate}}</div>
          <div class="item">审核状态：{{ruleForm.auditStatus==0?'待审核':ruleForm.auditStatus==1?'审核通过':'审核不通过'}}</div>
        </div>
        <div style="display: flex;margin-top: 10px; color: #707070;" v-if="ruleForm.auditStatus==2">
          <div>不通过原因：</div>
          <div v-html="ruleForm.auditMark"></div>
        </div>
      </div>

    </el-form>

  </div>
</template>

<script>



export default {

  data() {
    return {
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示的行数
      pageSizeArr: [5, 10, 20], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      categoryValue: "",
      projectName: "",
      tableData: [],
      dataList: [],

      loading: false,
      ruleForm: {
        packageName: '',//套餐名称
        originalPrice: '', // 原价
        discountPrice: '', // 套餐价
        picUrl1: "", //商品图片
        picUrl2: "", //商品图片
        picUrl3: "", //商品图片
      },
      inputValue: '',
      add: null,

    }
  },
  created() {
    this.getDataList()
  },

  methods: {
    // 详情
    getDataList() {
      this.loading = true;
      this.$axios.get(this.$api.selectProjectPackageDetail, {
        params: {
          id: this.$route.query.id
        }
      }).then(res => {
        this.ruleForm = res.result
        this.dataList = res.result.infoVoList
        if (this.ruleForm.urlList && Array.isArray(this.ruleForm.urlList)) {
          this.$set(this.ruleForm, 'picUrl1', this.ruleForm.urlList[0] || '');
          this.$set(this.ruleForm, 'picUrl2', this.ruleForm.urlList[1] || '');
          this.$set(this.ruleForm, 'picUrl3', this.ruleForm.urlList[2] || '');
        } else {
          this.$set(this.ruleForm, 'picUrl1', '');
          this.$set(this.ruleForm, 'picUrl2', '');
          this.$set(this.ruleForm, 'picUrl3', '');
        }
        console.log(this.ruleForm.urlList);

        this.dataList = this.dataList.map(item => {
          return {
            ...item,
            initialValue: item.originalPrice
          }
        })
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error(error.desc)
      });
    },
  }

}
</script>

<style lang="scss" scoped>
.apply {
  // 1.基本信息
  .form {
    margin: 30px 20px;

    .title {
      font-size: 20px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .item {
      width: 33%; /* 100% / 4 = 25%，留一点空间避免浏览器计算误差 */
      margin-bottom: 30px;
      font-size: 16px;
      color: #707070;
    }
    ::v-deep .el-cascader {
      width: 367px;
    }
  }

  // 保质期天数
  .day {
    ::v-deep .el-form-item__label {
      color: #606266;
      font-size: 16px;
      padding-right: 30px;
    }

    ::v-deep.el-input__inner {
      background: #ffffff !important;
      border-radius: 10px 0 0 10px;
      border: none;
    }

    ::v-deep .el-input-group__append {
      background: #ffffff !important;
      border-radius: 0px 10px 10px 0;
      border: none;
      font-size: 20px;
      color: #606266;
    }
  }

  .submit-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 30px;
  }

  .pic {
    margin-left: 77px;
    color: #707070;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .picbox {
      margin-right: 20px;
    }
    .price {
      margin-right: 244px;
    }
  }
  .logo_pic {
    .busilicense {
      width: 180px;
      height: 120px;
      margin-right: 10px;
    }
  }
  .delpic {
    position: absolute;
    top: -12px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }

  .delpic1 {
    right: -15px;
  }

  .delpic2 {
    right: -134px;
  }

  .delpic3 {
    right: -250px;
  }
}

// common
.dialog_row {
  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  // width: 850px;
  ::v-deep.el-form-item {
    margin-right: 100px;
  }

  ::v-deep.el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 30px;
  }
}

/* input number类型取消增减箭头*/
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

// 光标上移
::v-deep.el-input__inner {
  line-height: 1px !important;
}

::v-deep .ql-editor {
  min-height: 200px;
  max-height: 500px;
}
</style>
